import VConsole from 'vconsole'

const vConsole = (process.env.clientType !== 'web' && process.env.runtime !== 'prod') ? new VConsole() : ''
export default vConsole
